import React, { useState } from 'react';
import { Chip, SearchInput, Toast, useT } from '@repo/common';
import HeaderText from '../Common/HeaderText';
import UserListHeader from './UserListHeader';
import UserList from './UserList';

const FILTERS = [
  { value: 'ALL', label: 'All', labelKr: '전체' },
  { value: 'BUSINESS', label: 'Business', labelKr: '기업' },
  { value: 'CREATOR', label: 'Creator', labelKr: '크리에이터' },
  { value: 'BLOCKED', label: 'Blocked', labelKr: '차단' },
  { value: 'DELETED', label: 'Deleted', labelKr: '탈퇴' },
];

const UserManagement = () => {
  const t = useT();
  const [filter, setFilter] = useState('ALL');
  const [searchInput, setSearchInput] = useState('');
  const [keyword, setKeyword] = useState('');
  const [toast, setToast] = useState(null);

  const showToast = (title, type = 'success') => {
    setToast(null);
    setTimeout(() => setToast({ title, type }), 10);
  };

  return (
    <div className='flex flex-col w-full min-w-0 items-start'>
      <HeaderText label={t('User Management', '회원 관리')} />

      {/* 태블릿 가로 이상에서는 한 줄, 그 아래에서는 칩 줄 + 검색창 순으로 쌓인다 */}
      <div className='flex flex-col tabletH:flex-row tabletH:justify-between tabletH:items-center gap-3 tabletH:gap-4 w-full px-1 tabletH:px-3 pb-4'>
        <div className='flex flex-wrap items-center gap-2'>
          {FILTERS.map(({ value, label, labelKr }) => (
            <Chip
              key={value}
              type='fill'
              state={filter === value ? 'selected' : 'default'}
              onClick={() => setFilter(value)}
              hideIcon
            >
              {t(label, labelKr)}
            </Chip>
          ))}
        </div>
        <div className='w-full tabletH:w-[280px] desktopL:w-[320px] flex-shrink-0'>
          <SearchInput
            id='admin-user-search'
            value={searchInput}
            onChange={(value) => {
              setSearchInput(value);
              // 지우기 버튼으로 비우면 바로 전체 목록으로 돌아간다
              if (!value) setKeyword('');
            }}
            onEnter={(value) => setKeyword(value.trim())}
            placeholder={t('Search name, email or ID', '이름 · 이메일 · ID 검색')}
            activePlaceholder={t('Press Enter to search', 'Enter를 눌러 검색')}
          />
        </div>
      </div>

      <UserListHeader />
      <UserList
        filter={filter}
        keyword={keyword}
        onActionSuccess={(title) => showToast(title, 'success')}
        onActionFailed={(title) => showToast(title, 'error')}
      />

      {toast && (
        <div className='fixed bottom-6 left-0 right-0 px-4 z-[1000] flex justify-center'>
          <div className='w-full' style={{ maxWidth: '320px' }}>
            <Toast
              type={toast.type}
              title={toast.title}
              hierarchy='important'
              direction='up'
              customWidth='100%'
              onClose={() => setToast(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
